module.exports = __webpack_public_path__ + "img/project_8.fc977e0c.png";